<template lang="pug">
g-data-table.confirmationTable(
  :items="pagination.data",
  :options.sync="options",
  :server-items-length="pagination.total",
  show-select,
  v-model="selected",
  v-bind="{ headers, loading }"
)
  template(v-slot:item.Orderline_Additional_Information.ShipByDate="{ item, header }")
    .item-extra(:class="{ ['orange--text']: isHighlight($getExtraFieldValue(item, header)) }") {{ $getExtraFieldValue(item, header)}}
  template(v-slot:item.Orderline_Additional_Information.SpecialProject="{ item, header }")
    .item-extra {{ $getExtraFieldValue(item, header)}}
  template(v-slot:item.Orderline_Additional_Information.INCOTERM="{ item, header }")
    .item-extra {{ $getExtraFieldValue(item, header)}}
  template(v-slot:top)
    v-row.table__title
      v-col.h2.primary--text {{ $t('PendingConfirmation.pendingConfirmation') }}
    v-row.table__top
      v-col.py-0
        app-entity-search(
          :criteria="[]",
          @pagination="setPagination",
          :loads="loads",
          :entity="entity",
          :rowsPerPage="options.itemsPerPage || null"
          :wheres="pagination.where"
        )
      v-col.pt-4(cols="auto")
        g-btn.h8(
          color="primary",
          @click.stop="dialog = true"
          :disabled="!selected.length"
        ) Confirm Order Lines
    v-dialog(v-model='dialog', persistent, max-width="979")
      v-card.px-10.py-5
        v-icon.dialog__close(@click='dialog = false; partyCreation = false;') mdi-close
        v-card-title.h2.primary--text {{ $t('PendingConfirmation.confirmOrderLines') }}
        v-card-text
          v-row
            v-col(cols="4")
              v-menu(v-model='menu', :close-on-content-click='false', transition='scale-transition', offset-y, min-width='290px')
                template(v-slot:activator='{ on, attrs }')
                  v-text-field(v-model='requestedPickUpDate', label='Requested Pick-up Date', outlined, append-icon='mdi-calendar', readonly, v-bind='attrs', v-on='on')
                v-date-picker(v-model='requestedPickUpDate', :min="nowDate", @input="menu = false")
          v-row(v-if="!partyCreation")
            v-col(cols="12")
              app-simple-entity-search(v-model="collectionPoint", :entity="partyEntity")
            v-col(cols="12", v-if="collectionPoint")
              app-entity-display(:value="trimmedCollectionPoint", :edit="false")
          v-row
            v-col.py-0(cols="auto", v-if="!partyCreation")
              g-btn(@click="resetInstance(); partyCreation = true;" color="primary") {{ $t('PendingConfirmation.createAParty') }}
            v-spacer
            v-col.py-0(cols="auto")
              g-btn.h8(color="primary", :disabled="disableSubmit" @click="submit") {{ $t('Common.submit') }}
          template(v-if="partyCreation")
            .h2.primary--text {{ $t('PendingConfirmation.createAParty') }}
            app-entity(:selector="false", :entity="partyEntity" :relation="partyEntity")
            v-row
              v-spacer
              v-col(cols="auto")
                g-btn.mx-2(color="error", outlined, @click="partyCreation = false") {{ $t('Common.cancel') }}
                g-btn(color="success", @click="saveParty", :disabled="disableSave") {{ $t('PendingConfirmation.saveParty') }}
</template>

<style lang="scss" scoped>
.g-data-table .row.table__top {
  flex-grow: 0;
}

.dialog__close {
  position: absolute;
  right: 15px;
  top: 15px;
}
</style>

<script>
import axios from 'axios';
import moment from 'moment-timezone';

export default {
  name: 'ConfirmationTable',
  data: () => ({
    options: {},
    selected: [],
    // Added wheres here for initial pagination
    // sent also to entity search
    pagination: {
      where: [
        'x => x.Responsibilities.Any(r => r.Status != 2 && r.Task.Type == "CONF")',
        'x => !x.ExtraData.Any(e => e.Key == "Orderline_Additional_Information.COL_DETAILS_ONHOLD" && e.Bool == true)',
        'x => x.RequestedQuantity.HasValue && x.RequestedQuantity > 0',
        'x => x.AvailableQuantity.HasValue && x.AvailableQuantity > 0',
        'x => x.Status.Name == "ControlComplete"'
      ],
    },
    // Same loads as endpoint call on load()
    loads: ['Product', 'ExtraData', 'Responsibilities.Task', 'Order'],

    dialog: false,
    nowDate: new Date().toISOString().slice(0,10),

    menu: false,
    requestedPickUpDate: null,

    partyCreation: false,
    disableSave: false,
    collectionPoint: null,
    loading: true,
  }),
  watch: {
    options: {
      handler(options) {
        this.load(options);
      }
    }
  },
  computed: {
    headers() {
      return  [
        { text: this.$t('PendingConfirmation.polNumber'), value: "externalId" },
        { text: this.$t('PendingConfirmation.itemId'), value: "product.externalId" },
        { text: this.$t('PendingConfirmation.itemDescription'), value: "product.name" },
        { text: this.$t('PendingConfirmation.requestedQuantity'), value: "requestedQuantity" },
        { text: this.$t('PendingConfirmation.urgencyLevel'), value: "urgencyLevel" },
        { text: this.$t('PendingConfirmation.shipByDate'), value: "Orderline_Additional_Information.ShipByDate", sortable: false, type:'DateTime' },
        { text: this.$t('PendingConfirmation.poDeliveryDate'), value: "dateDeliveryFrom", type:'DateTime' },
        { text: this.$t('PendingConfirmation.specialProject'), value: "Orderline_Additional_Information.SpecialProject", sortable: false },
        { text: this.$t('PendingConfirmation.incoterm'), value: "Orderline_Additional_Information.INCOTERM", sortable: false },
      ]
    },
    trimmedCollectionPoint() {
      if (!this.collectionPoint) return {};
      return _.omit(this.collectionPoint, [..._.get(ENV, 'ENTITY.FIELDS.IGNORE', []), 'deletedAt', 'history', 'businessScope', 'businessScopeId'])
    },
    entity() {
      return this.$findEntity('OrderLine');
    },
    partyEntity() {
      return this.$findEntity('Party');
    },
    disableSubmit() {
      return !(this.requestedPickUpDate && this.collectionPointId);
    },
    collectionPointId() {
      return (this.collectionPoint || {}).id;
    },
  },
  methods: {
    isHighlight(date) {
      let dateMoment = moment(date);
      if (!date || !dateMoment.isValid()) return false;
      // Highlight is any date 5 days or less before today
      let highlight = moment.utc().add(6, 'days');
      return highlight.isAfter(dateMoment, 'day');
    },
    getCollectionPointId({ id }) {
      this.collectionPointId = id;
    },
    setPagination(event) {
      //For CONF table, always have the same pagination.where
      event.where = this.pagination.where
      this.pagination = event;
    },
    getPagination(options = null, where = null) {
      options = options || this.options;
      if (!_.keys(options).length) return;
      // console.log('OPTS ', options)
      return {
        params: {
          page: options.page,
          pageSize: options.itemsPerPage,
          orderBy: "dateDeliveryFrom",
          desc: false,
          where: where,
        }
      };
    },
    async saveParty() {
      try {
        this.disableSave = true;
        var response = (await axios.post('entity/graph', this.$store.state.instance))
        this.collectionPoint = response.data;
        this.partyCreation = false;
      } finally {
        this.disableSave = false;
      }
    },
    resetInstance() {
      this.$store.commit('SET_ERRORS', {});
      this.$store.commit('SET_INSTANCE', { entityState: 4, _Entity: "Party" });
    },
    async submit() {
      try {
        const payload = {
          collectionPointId: this.collectionPointId,
          requestedPickUpDateFrom: this.requestedPickUpDate + 'T00:00',
          uids: this.selected.map(s => s.uid),
        };
        // CALL TO ENDPOINT
        await axios.post('orderLines/PortalCONF', payload)

        this.dialog = false;
        this.collectionPointId = null;
        this.requestedPickUpDate = null;
        this.selected = [];

        await this.load();
      } catch (e) {
        console.log(this.$cleanString(e));
      }
    },
    async load(options = null) {
      try {


        this.loading = true;
        const pagination = this.getPagination(options, this.pagination.where);
        let endpoint = this.$fetchLoad(
          "OrderLine",
          true,
          "Product",
          "ExtraData",
          'Responsibilities.Task',
          "Order"
        );
        this.pagination = (await axios.get(endpoint, {headers: {"isConfirmationTable": true}}, pagination)).data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
